// extracted by mini-css-extract-plugin
module.exports = {"header":"mobiletotal_header__w8t7x","avatar":"mobiletotal_avatar__1Zce-","name":"mobiletotal_name__2qfkd","howMuchDay":"mobiletotal_howMuchDay__3pwtv"};